import Slider from "react-slick"
import aak from "../../../../src/assets/home/aak.svg"
import AyohFoods from "../../../../src/assets/home/AyohFoods.svg"
import buhler from "../../../../src/assets/home/buhler.svg"
import CalPolyPomona from "../../../../src/assets/home/Cal-Poly-Pomona.svg"
import CheilJedang from "../../../../src/assets/home/CheilJedang.svg"
import DANONELOGO from "../../../../src/assets/home/DANONELOGO.svg"
import givaudan from "../../../../src/assets/home/givaudan.svg"
import ingredion from "../../../../src/assets/home/ingredion.svg"
import Mista from "../../../../src/assets/home/Mista.svg"
import OSUResourceImages from "../../../../src/assets/home/OSUResourceImages.svg"
import pacificfoods from "../../../../src/assets/home/pacificfoods.svg"
import sig from "../../../../src/assets/home/sig.svg"
import Stanford from "../../../../src/assets/home/Stanford.svg"
import "./style.css"


export default function CompanyCarousel() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className="justify-content-center specialClassForCarousel">
            <div className="commonInlinePadding carouselBlock section-container">
                <div className="slider-container">
                    <Slider {...settings}>
                        <div className="flexCenter">
                            <img src={givaudan} alt="givaudan" style={{ width: "12.5rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={ingredion} alt="ingredion" style={{ width: "4.875rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={sig} alt="sig" style={{ width: "4.75rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={buhler} alt="buhler" style={{ width: "12.5rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={aak} alt="aak" style={{ width: "8.5rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={pacificfoods} alt="pacificfoods" style={{ width: "7.9375rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={AyohFoods} alt="AyohFoods" style={{ width: "5.3125rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={CheilJedang} alt="CheilJedang" style={{ width: "10.0625rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={DANONELOGO} alt="DANONELOGO" style={{ width: "10.0625rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={Mista} alt="Mista" style={{ width: "5.625rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={Stanford} alt="Stanford" style={{ width: "8.8125rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={OSUResourceImages} alt="OSUResourceImages" style={{ width: "9.8125rem" }} />
                        </div>
                        <div className="flexCenter">
                            <img src={CalPolyPomona} alt="CalPolyPomona" style={{ width: "6.25rem" }} />
                        </div>
                    </Slider>
                </div>
            </div>
        </div>
    )
}